import { commonHeaders } from '../config';

const getResponseError = async (response: Response) => {
  if (response.status === 401) return new Error('Unauthorized');
  if (response.status === 403) return new Error('Forbidden');
  if (response.status === 500) return new Error('Ошибка на сервере');
  if (!response.ok) {
    const json = await response.json();
    const { message } = json ?? {};

    if (!message) return new Error('Ошибка');
    if (Array.isArray(message)) return new Error(`${message[0]}`);
    return new Error(message);
  }

  return null;
};

export const deleteRequest = async (url: string) => {
  const response = await fetch(url, {
    method: 'DELETE',
    headers: { ...commonHeaders, Authorization: localStorage.token },
  });

  const responseError = await getResponseError(response);
  if (responseError) throw responseError;
  if (response.status === 204) return {};

  return {};
};

export const get = async (url: string, raw?: boolean) => {
  const response = await fetch(url, {
    method: 'GET',
    headers: { ...commonHeaders, Authorization: localStorage.token },
  });

  const responseError = await getResponseError(response);
  if (responseError) throw responseError;
  if (response.status === 204) return {};

  return raw ? response : response.json();
};

export const put = async (url: string, body: any, raw?: boolean) => {
  const response = await fetch(url, {
    method: 'PUT',
    headers: { ...commonHeaders, Authorization: localStorage.token },
    body: JSON.stringify(body),
  });

  const responseError = await getResponseError(response);
  if (responseError) throw responseError;
  if (response.status === 204) return {};

  return raw ? response : response.json();
};

export const post = async (url: string, body: any, raw?: boolean) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { ...commonHeaders, Authorization: localStorage.token },
    body: JSON.stringify(body),
  });

  const responseError = await getResponseError(response);
  if (responseError) throw responseError;
  if (response.status === 204) return {};

  return raw ? response : response.json();
};

export const postFormData = async (
  url: string,
  body: FormData,
  raw?: boolean,
) => {
  const response = await fetch(url, {
    method: 'POST',
    headers: { accept: 'application/json', Authorization: localStorage.token },
    body,
  });

  const responseError = await getResponseError(response);
  if (responseError) throw responseError;
  if (response.status === 204) return {};

  return raw ? response : response.json();
};
